import { useParams } from '@suntex.core/nav'
import { TeamId } from '@suntex.fim/api-client'
import { TeamProvider, useTeam, useTeamMovePlayers } from '@suntex.fim/team'

import MovePlayersBoard from './MovePlayersBoard'

function TeamMovePlayersInner() {
  const { schoolId } = useTeam()
  const { teams, isLoading, reload } = useTeamMovePlayers()
  if (schoolId === null) {
    return null
  }
  return (
    <MovePlayersBoard
      schoolId={schoolId}
      teams={teams}
      isLoading={isLoading}
      reload={reload}
    />
  )
}

function TeamMovePlayers() {
  const { teamId: teamIdParam } = useParams<{ teamId: string }>()
  const parsed = Number(teamIdParam)
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return null
  }
  const teamId = parsed as TeamId
  return (
    <TeamProvider key={teamId} teamId={teamId}>
      <TeamMovePlayersInner />
    </TeamProvider>
  )
}

export default TeamMovePlayers
